import { render, staticRenderFns } from "./AdminComments.vue?vue&type=template&id=2febff70&"
import script from "./AdminComments.vue?vue&type=script&lang=js&"
export * from "./AdminComments.vue?vue&type=script&lang=js&"
import style0 from "./AdminComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports